import { Link } from "react-router-dom";
import "./DoingsStyles.css";
import DoingsData from "./DoingsData";
import { services } from "./servicesData";

// Os textos e imagens dos serviços vivem agora num sítio só (servicesData.js),
// partilhados entre esta secção da Home e a página /servicos. Para alterar um
// serviço, basta mexer lá.
function Doings() {
  return (
    <div className="doings">
      <h1>OS NOSSOS SERVIÇOS </h1>
      <h6>
        {" "}
        Na vanguarda da inovação em engenharia, oferecemos soluções precisas e
        eficientes para impulsionar os seus projetos.
      </h6>
      <div className="doingscard">
        {services.map((service) => (
          <DoingsData
            key={service.id}
            image={service.image}
            imageAlt={service.imageAlt}
            heading={service.title}
            text={service.description}
            link={`/servicos#${service.id}`}
          />
        ))}
      </div>
      <Link to="/servicos" className="doings-all-link">
        Ver todos os serviços
      </Link>
    </div>
  );
}

export default Doings;
